export class FeedbackAPIModel {
  FeedbackNamelist: JSON;


  FeedbackListAPI: string = "";
  FeedbackDetailsAPI: string = "";
  SaveFeedbackInfo: string = "";

  SuccessMsg: string = "Thanks you ";
  TopBannerImage: string = "";

  FeedbackTitle: string = "";
  FeedbackTopContent: string = "";
  Journal: string = "";
  ArticleNo: string = "";
  AuthorName: string = "";

  FeednackBottomContent: string = "";
  FeedbackRatings: string = "";
  FeedbackName: string = "";
  FeedbackDesc: any;
  


}
